import React from "react";
import PropTypes from "prop-types";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "@lib/i18n";

import CitroenLogo from "@components/shared/Icons/Citroen";
import Icon from "@components/shared/Icons/Icon";
import RequestButton from "@components/shared/RequestButton";
import Typography from "@components/shared/Typography";

import { deliveryPointType } from "@types";
import { getIsCountry } from "lib/getIsCountry";
import { COUNTRIES } from "@shared/constants";

const MapSelectionListItem = ({
  point,
  isActive,
  onDeliveryPointClick,
  onDeliveryPointSelect,
}) => {
  const { t } = useTranslation();
  const { name, address1, town, distance, addressCountry, postcode } = point;

  return (
    <div
      className={twMerge(
        "rounded-md px-2 py-4 grid grid-template-mapSelectionItem gap-2 transition duration-300 border",
        isActive
          ? "bg-white border-greyLight"
          : "border-greyLight/50 hover:bg-white/80"
      )}
      onClick={onDeliveryPointClick}
    >
      <div className="grid-area-icon flex items-start justify-center">
        <Icon
          className={twMerge(
            "w-6 h-auto",
            isActive ? "text-primaryOrange" : "text-primaryDark"
          )}
          icon={<CitroenLogo />}
        />
      </div>

      <div className="grid-area-name">
        <Typography
          className={twMerge(
            "font-semibold",
            isActive ? "text-primaryOrange" : "text-primaryDark"
          )}
        >
          {name}
        </Typography>
      </div>

      <div className="grid-area-address">
        <Typography className="text-sm">{address1}</Typography>
        <Typography className="text-sm">{`${postcode} ${town}`}</Typography>
        <Typography className="text-sm">{addressCountry}</Typography>
      </div>

      {distance && (
        <div className="grid-area-distance flex items-center min-[32rem]:justify-end min-[32rem]:items-start">
          <Typography
            className="text-sm"
            data-id={`delivery-point-distance-${distance}`}
          >
            {distance} {getIsCountry(COUNTRIES.GB) ? "MILES" : "KM"}
          </Typography>
        </div>
      )}

      <div className="grid-area-button">
        <div className="flex justify-end items-end size-full">
          <RequestButton
            data-id="delivery-point-select-button"
            triggerRequestCallback={onDeliveryPointSelect}
            variant={isActive ? "primary" : "secondary"}
            className="text-xs"
            size="small"
          >
            {isActive
              ? t("basket.delivery.selectDeliveryPointSelected")
              : t("basket.delivery.selectDeliveryPoint")}
          </RequestButton>
        </div>
      </div>
    </div>
  );
};

MapSelectionListItem.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onDeliveryPointClick: PropTypes.func.isRequired,
  onDeliveryPointSelect: PropTypes.func.isRequired,
  point: deliveryPointType,
};

export default MapSelectionListItem;
